import styled from 'styled-components';

import { Common, color } from '@stockbit/ui';

const { Autocomplete: BaseAutoComplete } = Common;

const Autocomplete = styled(BaseAutoComplete)`
  .ant-select-dropdown {
    width: 340px !important;
  }
  .ant-input-affix-wrapper {
    &:hover {
      border: 1px solid ${color.gainsboro};
    }
  }
  input {
    ::placeholder {
      font-family: var(--bold-font);
      color: #e3e3e3 !important;
    }
  }
`;

export { Autocomplete };
